var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantsOrangeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 758,
    viewBox: "0 0 1920 758",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -440,
    width: 2800,
    height: 760,
    fill: "#EC7405"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1872.22 0L1435 761H1715.78L2153 0H1872.22Z",
    fill: "#0099DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1904.2 0L1480 757H1529.8L1954 0H1904.2Z",
    fill: "#EC7405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsOrangeBg);
export default __webpack_public_path__ + "static/media/participants-orange-bg.660768169a8fcff7cf0d5ed5b8fd0169.svg";
export { ForwardRef as ReactComponent };